import React, { useEffect, useState } from 'react';

const STORAGE_KEY = 'apn-theme';

function currentIsDark() {
  return typeof document !== 'undefined' && document.documentElement.classList.contains('dark');
}

/** Light / dark switch. The initial theme is applied before paint by a script in public/index.html. */
export default function ThemeToggle({ className = '' }) {
  const [dark, setDark] = useState(currentIsDark);

  useEffect(() => {
    document.documentElement.classList.toggle('dark', dark);
  }, [dark]);

  const toggle = () => {
    const next = !dark;
    setDark(next);
    try {
      localStorage.setItem(STORAGE_KEY, next ? 'dark' : 'light');
    } catch (e) {
      // Storage blocked: theme still switches for this visit.
    }
  };

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={dark ? 'Switch to light mode' : 'Switch to dark mode'}
      aria-pressed={dark}
      className={`inline-flex h-10 w-10 items-center justify-center rounded-full border border-apn-line bg-apn-surface text-apn-ink transition-colors hover:border-apn-orange focus:outline-none focus-visible:ring-2 focus-visible:ring-apn-orange ${className}`}
    >
      {dark ? (
        <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
          <circle cx="12" cy="12" r="4.5" />
          <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
        </svg>
      ) : (
        <svg viewBox="0 0 24 24" className="h-5 w-5" fill="currentColor" aria-hidden="true">
          <path d="M20.5 14.3A8.5 8.5 0 0 1 9.7 3.5a8.5 8.5 0 1 0 10.8 10.8z" />
        </svg>
      )}
    </button>
  );
}
